export default "__VITE_ASSET__BRe1YxJn__"